import {ChangePasswordAction} from "./changePassword.types";

export const changePasswordRequestAction = (params: { old_password: string; new_password: string; }): ChangePasswordAction => ({ type: 'CHANGE_PASSWORD_REQUEST', params })
export const changePasswordSuccessAction = (): ChangePasswordAction => ({ type: 'CHANGE_PASSWORD_SUCCESS',})
export const changePasswordFailureAction = (error?: any): ChangePasswordAction => ({ type: 'CHANGE_PASSWORD_FAILURE', params: error })